<template>
  <div class="inputs">
    <div class="section-header">User Details</div>
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label for="email">Email *</label>
          <b-form-input
            id="email"
            type="email"
            v-model="user.email"
            required
            :disabled="submitting || (user._id ? true : false)"
          ></b-form-input>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label for="phone">Phone</label>
          <b-form-input
            id="phone"
            type="text"
            v-model="user.phone"
            :disabled="submitting"
          ></b-form-input>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label for="firstName">First Name</label>
          <b-form-input
            id="firstName"
            type="text"
            v-model="user.firstName"
            :disabled="submitting"
          ></b-form-input>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label for="lastName">Last Name</label>
          <b-form-input
            id="lastName"
            type="text"
            v-model="user.lastName"
            :disabled="submitting"
          ></b-form-input>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label for="type">User Type *</label>
          <b-form-select
            id="type"
            v-model="user.type"
            :options="typeOptions"
            required
            :disabled="submitting"
          ></b-form-select>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label for="department">Department</label>
          <b-form-select
            id="department"
            v-model="user.department"
            :options="departmentOptions"
            :disabled="submitting"
          ></b-form-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label for="communicationPreference">Communication Preference</label>
          <b-form-select
            id="communicationPreference"
            v-model="user.communicationPreference"
            :options="communicationOptions"
            :disabled="submitting"
          ></b-form-select>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label for="password">
            {{
              user._id
                ? 'New Password (leave blank to keep current)'
                : 'Password'
            }}
          </label>
          <b-form-input
            id="password"
            type="password"
            v-model="password"
            :disabled="submitting"
            :required="!user._id"
          ></b-form-input>
        </div>
      </div>
    </div>
    <div class="section-header">Address (Optional)</div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="street1">Street Address</label>
          <b-form-input
            id="street1"
            type="text"
            v-model="user.address.street1"
            :disabled="submitting"
          ></b-form-input>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="street2">Street Address 2</label>
          <b-form-input
            id="street2"
            type="text"
            v-model="user.address.street2"
            :disabled="submitting"
          ></b-form-input>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label for="city">City</label>
          <b-form-input
            id="city"
            type="text"
            v-model="user.address.city"
            :disabled="submitting"
          ></b-form-input>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label for="state">State</label>
          <b-form-input
            id="state"
            type="text"
            v-model="user.address.state"
            :disabled="submitting"
          ></b-form-input>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group">
          <label for="zip">Zip</label>
          <b-form-input
            id="zip"
            type="text"
            v-model="user.address.zip"
            :disabled="submitting"
          ></b-form-input>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <label for="country">Country</label>
          <b-form-input
            id="country"
            type="text"
            v-model="user.address.country"
            :disabled="submitting"
          ></b-form-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserFormFields',
  props: {
    user: {
      type: Object,
      required: true,
    },
    submitting: {
      type: Boolean,
      required: true,
    },
    password: {
      type: String,
      default: '',
    },
  },
  data: function () {
    return {
      typeOptions: [
        { value: null, text: 'Select Type' },
        { value: 'ADMIN', text: 'Admin' },
        { value: 'ACCOUNTING', text: 'Accounting' },
        { value: 'SALES', text: 'Sales' },
        { value: 'ARCHITECTURE', text: 'Architecture' },
        { value: 'ENGINEERING', text: 'Engineering' },
        { value: 'CUSTOMER', text: 'Customer' },
        { value: 'CONTRACTOR', text: 'Contractor' },
        { value: 'MANUFACTURING', text: 'Manufacturing' },
        { value: 'MANAGER', text: 'Manager' },
        { value: 'INSTALLER', text: 'Installer' },
      ],
      departmentOptions: [
        { value: null, text: 'Select Department' },
        { value: 'ADMIN', text: 'Admin' },
        { value: 'ACCOUNTING', text: 'Accounting' },
        { value: 'SALES', text: 'Sales' },
        { value: 'ARCHITECTURE', text: 'Architecture' },
        { value: 'ENGINEERING', text: 'Engineering' },
        { value: 'CUSTOMER', text: 'Customer' },
        { value: 'CONTRACTOR', text: 'Contractor' },
        { value: 'MANUFACTURING', text: 'Manufacturing' },
        { value: 'MANAGER', text: 'Manager' },
        { value: 'INSTALLER', text: 'Installer' },
      ],
      communicationOptions: [
        { value: 'EMAIL', text: 'Email' },
        { value: 'PHONE', text: 'Phone' },
        { value: 'BOTH', text: 'Both' },
      ],
    }
  },
  watch: {
    password(newVal) {
      this.$emit('update:password', newVal)
    },
  },
}
</script>

<style lang="scss" scoped>
.section-header {
  font-size: 18px;
  text-decoration: underline;
  margin-bottom: 6px;
  margin-top: 8px;
  font-weight: 500;
}
</style>


